import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import App from "./components/App/App";
import 'semantic-ui-less/semantic.less';

import "./i18n";

ReactDOM.render(<App />, document.getElementById("root"));
